export default function HeroSection() {
  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden"
    >
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20soft%20illustration%20of%20a%20romantic%20manga%20scene%20with%20cherry%20blossoms%20and%20a%20couple%20holding%20hands%20under%20a%20sunset%20sky%2C%20soft%20pastel%20pink%20and%20peach%20tones%2C%20dreamy%20atmosphere%2C%20anime%20art%20style%2C%20gentle%20lighting%2C%20emotional%20and%20sweet%20mood%2C%20clean%20composition&width=1600&height=900&seq=hero-bg-tianyou&orientation=landscape"
          alt="甜柚漫画 - 甜蜜恋爱漫画世界"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-black/35"></div>
      </div>

      <div className="relative z-10 w-full section-container">
        <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white/15 backdrop-blur-sm border border-white/20 mb-6">
              <i className="ri-heart-fill text-primary-400 text-sm"></i>
              <span className="text-white/90 text-sm font-medium">甜蜜恋爱漫画第一站</span>
            </div>

            <h1 className="w-full">
              <span
                className="block text-3xl md:text-5xl lg:text-6xl font-black text-white leading-tight"
                style={{ fontFamily: 'var(--font-heading)' }}
              >
                甜柚漫画
              </span>
              <span className="block text-xl md:text-2xl lg:text-3xl font-bold text-primary-300 mt-2 leading-snug">
                甜宠恋爱 · 校园纯爱 · 少女漫画免费全集
              </span>
            </h1>

            <p className="text-white/80 text-base md:text-lg leading-relaxed mt-5 max-w-lg mx-auto lg:mx-0">
              甜柚漫画每日精选热门甜宠恋爱与治愈校园纯爱漫画，涵盖日漫、韩漫海量免费全集。
              无论你喜欢高甜撒糖还是温暖治愈，这里都有让你心动的甜蜜故事。
              新作每日更新，热门连载同步追更，好看停不下来。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-4 md:gap-8 mt-6">
              <div className="flex items-center gap-2">
                <span className="text-accent-400 text-2xl md:text-3xl font-black">2000+</span>
                <span className="text-white/70 text-sm">部漫画作品</span>
              </div>
              <div className="w-px h-6 bg-white/20 hidden sm:block"></div>
              <div className="flex items-center gap-2">
                <span className="text-accent-400 text-2xl md:text-3xl font-black">每日</span>
                <span className="text-white/70 text-sm">稳定更新</span>
              </div>
              <div className="w-px h-6 bg-white/20 hidden sm:block"></div>
              <div className="flex items-center gap-2">
                <span className="text-accent-400 text-2xl md:text-3xl font-black">全免费</span>
                <span className="text-white/70 text-sm">无需付费</span>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3 mt-8">
              <a
                href="#ranking"
                className="inline-flex items-center gap-2 px-8 py-3.5 rounded-full bg-primary-500 text-white font-bold text-base whitespace-nowrap hover:bg-primary-600 transition-colors cursor-pointer"
              >
                <i className="ri-fire-fill"></i>
                查看热门榜单
              </a>
              <a
                href="#updates"
                className="inline-flex items-center gap-2 px-8 py-3.5 rounded-full bg-white/15 backdrop-blur-sm border border-white/30 text-white font-medium text-base whitespace-nowrap hover:bg-white/25 transition-colors cursor-pointer"
              >
                <i className="ri-time-line"></i>
                今日最新更新
              </a>
            </div>
          </div>

          <div className="flex-1 w-full flex justify-center lg:justify-end">
            <div className="relative w-[280px] h-[380px] md:w-[340px] md:h-[460px] rounded-2xl overflow-hidden border-2 border-white/20 shadow-2xl">
              <img
                src="https://readdy.ai/api/search-image?query=A%20beautiful%20shoujo%20manga%20style%20illustration%20of%20a%20young%20couple%20in%20school%20uniforms%20sharing%20a%20sweet%20moment%20under%20cherry%20blossom%20trees%2C%20warm%20golden%20sunset%20light%2C%20soft%20pastel%20colors%2C%20romantic%20and%20pure%20atmosphere%2C%20detailed%20anime%20art%2C%20gentle%20expressions%2C%20floating%20petals%2C%20clean%20composition%20with%20warm%20pink%20and%20peach%20tones&width=680&height=920&seq=hero-visual-manga&orientation=portrait"
                alt="甜柚漫画 - 甜宠恋爱少女漫画"
                className="w-full h-full object-cover"
              />
              <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/40 to-transparent p-4">
                <span className="text-white text-sm font-medium">每日甜蜜新作</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}